import { render, staticRenderFns } from "./dataframe.vue?vue&type=template&id=b505d16e&scoped=true&"
import script from "./dataframe.vue?vue&type=script&lang=js&"
export * from "./dataframe.vue?vue&type=script&lang=js&"
import style0 from "./dataframe.vue?vue&type=style&index=0&id=b505d16e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b505d16e",
  null
  
)

export default component.exports